import { Component } from "react";

// A render-time throw anywhere below this unmounts the whole tree and leaves a
// blank page with nothing but a console message. Showing the error instead
// turns "the site went white" into something diagnosable.
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("SlantScan crashed while rendering:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="mx-auto max-w-lg px-5 py-24 text-center" data-testid="error-boundary">
        <h1 className="font-serif text-3xl font-black tracking-tight text-ink">
          Something broke on our end
        </h1>
        <p className="mt-3 text-dim">
          Reloading usually fixes it. If it keeps happening, the details are in your
          browser console.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-6 rounded-xl bg-ink px-5 py-3 font-medium text-paper transition-[transform,background-color] duration-150 ease-out hover:bg-ink/85 active:scale-[0.97]"
        >
          Reload
        </button>
        <pre className="mt-8 overflow-x-auto rounded-lg bg-subtle p-4 text-left text-xs text-dim">
          {String(this.state.error?.message || this.state.error)}
        </pre>
      </main>
    );
  }
}
